import React, { useContext, useState } from 'react';
import ContentCard from './ContentCard';
import {UserContext} from '../contexts/user-context';
import { withTranslation, Trans } from 'react-i18next';
import {Link} from "react-router-dom";

function UserForgotPasswordComponent(props) {

  const userContext = useContext(UserContext)
  const [email, setEmail] = useState(userContext.user.email);

  const emailError = (userContext.errors != null && userContext.errors.email != null);
  const inputClassName = emailError ? 'form-control is-invalid' : 'form-control';
  const formClassName = userContext.errors != null ? '' : 'was-validated';

  return (
    <ContentCard title={<Trans i18nKey="password_forgotten" />} text={<Trans i18nKey="password_forgotten_email" />}>
      <form className={formClassName}
        onSubmit={(event)=> {
          event.preventDefault()
          event.stopPropagation()
          userContext.forgotPassword(email)
        }}>
        <div className="">
            <input type="hidden" name="authenticity_token" id="csrf-token" value={document.querySelector('[name=csrf-token]').content} />
            <div className="form-floating my-3" style={props} >
                <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    className={inputClassName}
                    id="emailInput"
                    placeholder="name@example.com" />
                  <label htmlFor="emailInput"><Trans i18nKey="email_address" /></label>
                {emailError &&
                    <div className="invalid-feedback">
                        {userContext.errors.email.map((error) => (
                            <span key={error}><Trans i18nKey="email" /> {error}</span>
                        ))}
                    </div>
                }
            </div>
        </div>
        <div className="mt-4 mb-3 d-grid gap-2 col-9 mx-auto">
            <button className="btn btn-primary btn-lg" type="submit">
                  <i className="obn obn-privacy-2 me-2"></i><Trans i18nKey="send_instructions" />
            </button>
            <Link to="/" className="link text-center"><Trans i18nKey="sign_in" /></Link>
            {/* <Link to="/users/sign_up" className="link text-center"><Trans i18nKey="create_account" /></Link> */}
        </div>
      </form>
    </ContentCard>
  );
}

export default withTranslation()(UserForgotPasswordComponent);